import {axiosInstances} from "../index";
import axios from "axios";

export default function setAxiosAuthorization(authorization: string) {
    axios.defaults.headers.common["Authorization"] = authorization;
    axiosInstances.forEach((axios) => axios.defaults.headers.common["Authorization"] = authorization);
}
